import React from 'react';
import {MatchPropsInterface} from './matchInterface';

const Match = ({match}: MatchPropsInterface): React.ReactNode => {
    const {player_one, player_two, score_one, score_two} = match || {};

    return <div className="match">
        <div className="team">
            {match && <>
                <span title={player_one}>{player_one}</span>
                {score_one && <span>{score_one}</span>}
            </>}
        </div>
        <div className="team">
            {match && <>
                <span title={player_two}>{player_two}</span>
                {score_two && <span>{score_two}</span>}
            </>}
        </div>
    </div>;
};

export default Match;
